module.exports = __webpack_public_path__ + "img/img-114.0e9017bc.png";